import React, { useContext, useState } from 'react';
import loginIcon from '../assets/logo3.png';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import Context from '../context';

const Login = () => {
    const [ showPassword, setShowPassword] = useState(false);
    const [ data, setData ] = useState({
        email : "",
        password : ""
    });
    const navigate = useNavigate();
    const { fetchUserDetails, fetchUserAddToCart } = useContext(Context);

    const handleOnChange = (e) => {
        const { name, value } = e.target

        setData((preve)=>{
            return{
                ...preve,
                [name] : value
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try{
           // const authToken = localStorage.getItem("authToken");
            const dataResponse = await fetch(SummaryApi.signIn.url,{
                method: SummaryApi.signIn.method,
                credentials : "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body : JSON.stringify(data)
            });

            const dataApi = await dataResponse.json();

            if (dataApi.success) {
                toast.success(dataApi.message);
        // backend returns token inside `data` field (per your backend)
              //const tokenFromApi = dataApi.data || dataApi.token || null;
              //if (tokenFromApi) {
               // localStorage.setItem("authToken", tokenFromApi);
              //} else {
                // token might not be needed because server sends cookie. keep localStorage cleared to avoid mismatch.
                localStorage.removeItem("authToken");
              //}
              
              const guestCart = JSON.parse(localStorage.getItem("guest_cart") || "[]");

      if (guestCart.length) {
        try {
          for (let pid of guestCart) {
            await fetch(SummaryApi.addToCartProduct.url, {
              method: SummaryApi.addToCartProduct.method,
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ productId: pid })
            });
          }

          localStorage.removeItem("guest_cart");
          // optional message
          // toast.success("Your previous cart is restored");
        } catch (err) {
          //console.error("Guest cart merge failed:", err);
        }
      }
               await fetchUserDetails();
                await fetchUserAddToCart();
                navigate('/');

            } else {
                toast.error(dataApi.message);
            }

        } catch (error) {
            toast.error("An error occurred, please try again.");
            //console.error("Error during login:", error);
        }
    }


  return (
    <section id='login'>
        <div className='mx-auto container p-10'>
            <h4 className='text-center p-4'>Note :- New User? Please Register Here <Link to={"/sign-up"} className='text-orange-900 hover:text-orange-950 underline'>Register</Link></h4>
            <div className='bg-white p-5 w-full max-w-sm mx-auto shadow rounded-2xl'>
                <div className='w-20 h-20 mx-auto'>
                    <img src={loginIcon} alt='login icon' />
                </div>

                <form className='pt-6 flex flex-col gap-2' onSubmit={handleSubmit}>
                    <div className='grid'>
                        <label>Email : </label>
                        <div className='bg-slate-100 p-2 rounded-full'>
                            <input type='email' 
                            placeholder='enter email'
                            name='email'
                            value={data.email}
                            onChange={handleOnChange}
                            className='w-full h-full outline-none bg-transparent' />
                        </div>
                    </div>

                    <div>
                        <label>Password : </label>
                        <div className='bg-slate-100 p-2 flex rounded-full'>
                            <input type={showPassword ? "text" : "password"} 
                            placeholder='enter password' 
                            name='password'
                            value={data.password}
                            onChange={handleOnChange}
                            className='w-full h-full outline-none bg-transparent' />
                            <div className='cursor-pointer text-xl' onClick={()=>setShowPassword((preve)=>!preve)}>
                                <span>
                                    {
                                        showPassword ? (<FaEyeSlash />) : (<FaEye />)
                                    }

                                </span>
                            </div>
                        </div>
                        <Link to={"/forgot-password"} className='block w-fit ml-auto hover:underline hover:text-orange-900'>
                            Forgot Password ?
                        </Link>
                    </div>

                    <button className='bg-[#5a3620] text-white px-6 py-2 w-full max-w-[150px] rounded-full hover:scale-110 transition-all mx-auto block mt-6'>Login</button>
                </form>
                {/*<p className='my-5'>Don't have account ? <Link to={"/sign-up"} className='text-orange-900 hover:text-orange-950 underline'>Sign up</Link></p>*/}
            </div>

        </div>
    </section>
  )
}

export default Login